<template>
    <router-view />
  </template>
  
  <script>
  export default {
    name: 'LangueWrapper',
  };
  </script>